import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import template from './campaign-type-template.pug';

export class CampaignTypeColumn extends CampaignuiBaseColumn {
  constructor({ i18n, permissions }) {
    super({
      name: 'CampaignType',
      property: ['CampaignType', 'CampaignMigrationStatus'],
      title: i18n.getString('ColumnName_CampaignType'),
      sortable: 'CampaignType',
      type: 'string',
    });
    this.i18n = i18n;
    this.IsRenameHotelToLodgingEnabled = permissions && permissions.dynamic && permissions.dynamic.IsRenameHotelToLodgingEnabled;
  }

  pickProperty(item) {
    return {
      CampaignType: item.CampaignType,
      CampaignMigrationStatus: item.CampaignMigrationStatus,
      i18n: this.i18n,
    };
  }

  template({ value }) {
    if (this.IsRenameHotelToLodgingEnabled && value.CampaignType === 'Hotel') {
      // When enable IsRenameHotelToLodgingEnabled, show text as "Lodging"
      value.CampaignType = 'Lodging'; // eslint-disable-line no-param-reassign
    }
    return template({
      CampaignType: value.CampaignType,
      CampaignMigrationStatus: value.CampaignMigrationStatus,
      i18n: this.i18n,
    });
  }
}
